

import React from 'react';
import '../../css/Footer.css';
import CaralystLogo from '../../assets/caralyst_logo.svg';
const Footer = () => {
    const logoLink = () => {
    }

    const onClickLink = (e, link) => {
        e.preventDefault();
        window.open(link)
    }

    return (
        <div className="footer">
            <img onClick={logoLink} src={CaralystLogo} width="95"/>
            <div className="links">
                <a href="https://caralyst.io">ABOUT US</a>
                <a href="#" onClick={e => onClickLink(e, "https://documents.caralyst.io/Online+Privacy+Policy.docx.pdf")}>PRIVACY POLICY</a>
                <a href="#" onClick={e => onClickLink(e, "https://documents.caralyst.io/Website+Terms+of+Use.docx.pdf")}>TERMS OF SERVICE</a>
                <a href="https://forms.gle/VcaSfnVHZsfPYytR7">FEEDBACK</a>
            </div>
            <span className="arr">All rights reserved ©</span>
        </div>
    );
}

export default Footer;
